import React, { useMemo } from 'react'

import { MyModalSlider } from '@interstellar-component'
import { useReportEnquiry } from './Context'
import ReportEnquiryHeader from './components/ReportEnquiryHeader'
import ReportEnquiryMetrics from './components/ReportEnquiryMetrics'
import ReportEnquiryTable from './components/ReportEnquiryTable'
import NewEnquirySlider from './components/NewEnquirySlider'
import EmployeeListSlider from './components/EmployeeListSlider'
import AdminVerificationSlider from './components/AdminVerificationSlider'
import AwaitingConsentSlider from './components/AwaitingConsentSlider'
import SentToClikSlider from './components/SentToClikSlider'

const SLIDER_COMPONENTS = {
  'new-enquiry': NewEnquirySlider,
  'employee-list': EmployeeListSlider,
  'admin-verification': AdminVerificationSlider,
  'awaiting-consent': AwaitingConsentSlider,
  'sent-to-clik': SentToClikSlider,
}

function ReportEnquiry() {
  const { sliderStack, popSlider } = useReportEnquiry()

  // Render the whole stack inside one MyModalSlider so secondary panels
  // (e.g. employee-list) sit side-by-side with the primary form instead of
  // replacing it. flex-row-reverse keeps the first-pushed slider anchored
  // to the right edge while newer pushes flow leftward.
  const stackElement = useMemo(() => {
    if (sliderStack.length === 0) return null
    return (
      <div className="flex h-full flex-row-reverse">
        {sliderStack.map((slider, index) => {
          const Component = SLIDER_COMPONENTS[slider.current]
          if (!Component) return null
          return (
            <Component
              key={`${slider.current}-${index}`}
              {...(slider.props || {})}
            />
          )
        })}
      </div>
    )
  }, [sliderStack])

  return (
    <div className="flex h-full w-full flex-col bg-gray-50/50">
      <MyModalSlider
        open={sliderStack.length > 0}
        scrim
        element={stackElement}
        onClose={popSlider}
      />

      <div className="flex w-full flex-1 min-h-0 flex-col">
        <ReportEnquiryHeader />
        <ReportEnquiryMetrics />
        <ReportEnquiryTable />
      </div>
    </div>
  )
}

export default ReportEnquiry
